<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header border-0">
        <button (click)="closeModal()" class="floating-btn d-flex">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#56647C" class="bi bi-arrow-left-short" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"/>
              </svg>
        </button>
        <h4 class="modal-title" id="modal-basic-title">
            {{ currentRoute == 'datalabs' ? 'DataLabs Prompts': 'Play Prompts' }}
        </h4>
    </div>
    <div class="modal-body pt-0">
        <p class="d-md-block mt-3 mb-5 d-none text-center secondary-title">
            Please choose the below prompt
        </p>
        <div class="offset-lg-2 col-lg-8 col-12 p-lg-0 welcome-content">
            <div class="row row-cols-1 row-cols-md-3 g-md-4 g-2 mb-5 pb-5">
                <div class="col-6 col-md-6 col-lg-4 col-xl-4 gap-10" *ngFor="let list of promptList"
                    (click)="sentToInput(list?.prompt)">
                    <div class="card shadow-sm rounded-3 border-1 border-light text-left" role="button" tabindex="0">

                        <div class="card-body pl-2 pr-2 pt-1 pb-1">
                            <div class="d-flex">
                                <div class="flex-shrink-0">
                                    <span *ngIf="list?.icon" class="icon">
                                        <!-- <img [src]="getIconPath(list.icon)" [alt]="list?.title" /> -->
                                        <app-svg-icon [iconName]="list?.icon"></app-svg-icon>
                                    </span>
                                </div>
                                <div class="flex-grow-1 ms-2">
                                    <h6 class="prompt-title">
                                        {{ list?.title }}
                                    </h6>
                                </div>

                            </div>
                            <p class="prompt-text text-secondary pt-1">{{ list?.prompt | capitalize |
                                truncateText:120:true }}</p>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="c('Save click')">Save</button>
    </div> -->
</ng-template>



<button (click)="openModal(content)" class="view-more btn-md btn btn-primary">
    <svg xmlns="http://www.w3.org/2000/svg" class="me-2" width="17" height="17" viewBox="0 0 17 17" fill="none">
        <path
            d="M5.85776 3.64225L8.5 1L11.1422 3.64225L8.50037 6.28449L5.85776 3.64225ZM10.7155 8.5L13.3578 5.85776L16 8.5L13.3581 11.1422L10.7155 8.5ZM1 8.5L3.64225 5.85776L6.28449 8.5L3.64262 11.1422L1 8.5ZM5.85776 13.3578L8.5 10.7155L11.1422 13.3578L8.50037 16L5.85776 13.3578Z"
            stroke="#007199" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    View prompts
</button>